import {
  faArrowLeft,
  faArrowRight,
  faCalculator,
  faCar,
  faCreditCard,
  faFile,
  faFileCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { Select } from '../../../@core/components/form/Select';
import Wizard from '../../../@core/components/wizard';
import {
  editCollectionRegister,
  handleChangeController,
  initNormalForm,
} from '../../../redux/actions/form';
import { removeError } from '../../../redux/actions/validator';
import { StatusContext } from '../../../utility/context/StatusContext';
import { serverRequest } from '../../../utility/helpers/Axios/serverRequest';
import { useErrorHandler } from '../../../utility/hooks/errorHandler/useErrorHandler';
import { FormCalculator } from '../../../views/addons/FormCalculator';
import { FormDocumention } from '../../../views/addons/FormDocumention';
import { FormPayment } from '../../../views/addons/FormPayment';
import { ModelSelect } from '../../../views/addons/ModelSelect';
import { RadioList } from '../../../views/addons/RadioList';
import { CToast } from '../../../views/addons/ToastMessage';
import { WizardInterpreter } from '../contactForm/ContactForm';
import './styles/wizard-form.scss';
import vehicle from './fixed/vehicle';
import tradeForm from './fixed/tradeForm';

const demoInit = {
  buyer: { status: true, email: '' },
  vehicle: {
    vehicleType: 'Car',
    modelId: null,
    modelStr: '',
    ccaaId: null,
    enrollmentDate: '',
    brand: null,
    fuel: '',
  },
  itp: {},
  saleProductTypes: ['OwnershipChange', 'ITP'],
  documents: {},
  addTraficReport: false,
  addEnvironmentalBadge: false,
  total: 0,
};

export const OwnershipChange = () => {
  const [stepper, setStepper] = useState(null);
  const { form, select } = useSelector((state) => state);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const err = useErrorHandler('itp', false);
  const [alreadyCalculated, setAlreadyCalculated] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    dispatch(initNormalForm(demoInit));
  }, []);

  const validate = async () => {
    if (
      form.buyer.email === '' ||
      form.buyer.email === undefined ||
      form.buyer.email === null
    ) {
      CToast({ title: 'Completa los campos', message: '- Correo' });
    } else {
      const brandStr = select.brands.find(
        (b) => b.value === form.vehicle.brand,
      )?.label;
      if (!alreadyCalculated) {
        await serverRequest(
          'sale',
          null,
          {
            ...form,
            documents: [],
          },
          'POST',
        ).then((e) => {
          if (!!e) {
            dispatch(editCollectionRegister([], { name: 'id', value: e.id }));
            setAlreadyCalculated(true);
          }
        });
      }
      await serverRequest(
        'cacl',
        null,
        { brandStr, ...form.vehicle },
        'POST',
      ).then((e) => {
        if (e?.hasErrors) err.errorHandler(e.errorList);
        else if (!!e) {
          dispatch(editCollectionRegister([], { name: 'itp', value: e }));
          dispatch(
            editCollectionRegister(['vehicle'], {
              name: 'brandStr',
              value: brandStr,
            }),
          );
          setActiveIndex(activeIndex + 1);
        }
      });
    }
  };

  const nextStep = () => {
    setActiveIndex(activeIndex + 1);
  };

  const prevStep = () => {
    setActiveIndex(activeIndex - 1);
  };

  const submitFiles = async (files = [], fileEndPoint, id) => {
    if (files.length !== 0) {
      for (const file of files) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('dest', 'sale');
        await serverRequest(fileEndPoint, id, formData, 'FILEUPLOAD');
      }
    }
  };

  const finishOwnerShip = async () => {
    const {
      saleProductTypes,
      addTraficReport,
      addEnvironmentalBadge,
      documents,
    } = form;
    const files = [];
    const newDocuments = [];
    if (addTraficReport) saleProductTypes.push('DGTReport');
    if (addEnvironmentalBadge) saleProductTypes.push('EnviromentalTag');

    for (const key in documents) {
      if (Object.hasOwnProperty.call(documents, key)) {
        const document = documents[key];
        files.push(document.file);
        delete document.file;
        newDocuments.push(document);
      }
    }

    const sale = await serverRequest(
      'sale',
      null,
      {
        ...form,
        documents: newDocuments,
        oportunity: 0,
        sendMail: true,
      },
      'POST',
    );
    await submitFiles(files, 'saleFile', sale.id);
    dispatch(handleChangeController('id', sale.id));
  };

  return (
    <div className="w-100">
      <form className="w-100">
        <StatusContext.Provider value={[activeIndex, setActiveIndex]}>
          <Wizard
            type="modern-horizontal"
            ref={ref}
            steps={[
              {
                id: 'vehicle-wizard',
                title: 'Vehículo',
                subtitle: 'Datos del vehículo',
                icon: <FontAwesomeIcon icon={faCar} />,
                content: (
                  <>
                    <WizardInterpreter blocks={vehicle} />
                    <div style={{ textAlign: 'right' }}>
                      <Button
                        onClick={() => validate()}
                        className="shown.bs-stepper"
                        color="primary"
                      >
                        Siguiente{' '}
                        <FontAwesomeIcon
                          style={{ marginLeft: '3px' }}
                          icon={faArrowRight}
                          size={'1x'}
                        />
                      </Button>
                    </div>
                  </>
                ),
              },
              {
                id: 'price-wizard',
                title: 'Precio',
                subtitle: 'Calculadora',
                icon: <FontAwesomeIcon icon={faCalculator} />,
                content: <FormCalculator />,
              },
              {
                id: 'contact-wizard',
                title: 'Información',
                subtitle: 'Compra - Venta',
                icon: <FontAwesomeIcon icon={faFileCircleCheck} />,
                content: (
                  <>
                    <WizardInterpreter blocks={tradeForm} />
                    <div className="d-flex justify-content-between">
                      <Button
                        onClick={() => prevStep()}
                        className="shown.bs-stepper"
                        color="primary"
                      >
                        <FontAwesomeIcon
                          style={{ marginLeft: '3px' }}
                          icon={faArrowLeft}
                          size={'1x'}
                        />{' '}
                        Atrás
                      </Button>
                      <Button
                        onClick={() => nextStep()}
                        className="shown.bs-stepper"
                        color="primary"
                      >
                        Siguiente{' '}
                        <FontAwesomeIcon
                          style={{ marginLeft: '3px' }}
                          icon={faArrowRight}
                          size={'1x'}
                        />
                      </Button>
                    </div>
                  </>
                ),
              },
              {
                id: 'docs-wizard',
                title: 'Documentos',
                subtitle: 'Documentacion',
                icon: <FontAwesomeIcon icon={faFile} />,
                content: <FormDocumention finishOwnerShip={finishOwnerShip} />,
              },
              {
                id: 'payment-wizard',
                title: 'Pago',
                subtitle: 'Termina',
                icon: <FontAwesomeIcon icon={faCreditCard} />,
                content: <FormPayment />,
              },
            ]}
            options={{ linear: true }}
            instance={(el) => setStepper(el)}
          />
        </StatusContext.Provider>
      </form>
    </div>
  );
};
